import {needShowMultiComplexFields} from './ui'
import { get } from 'lodash'
import store from '@/store'
// 一些数据处理的方法

/**
 * @params data 最细维度的data对象
 * @praams value 表单的值
 * 后端需要的data结构是
 * {
 *      name: 'prop_2222',
 *      defaultValue: '', // 当表单的值为数组的时候需要转换成下面children这样，然后此defaultValue置空
 *      children: [
 *          {
 *              defalutValue: ''             
 *          }
 *      ]
 * }
 * */ 
export function getValueDisplayName(itemUi, itemV) {
    let { defaultValue } = itemV || {}
    let valueDisplayName = ''
    if (itemUi?.options?.length) {
        try {
            defaultValue = defaultValue ? JSON.parse(defaultValue) : []
        } catch (error) {
            
        }
        if (defaultValue instanceof Array) {
            valueDisplayName = defaultValue.map(v => itemUi.options.find(op => op.value == v)?.displayName).filter(Boolean)
            valueDisplayName = valueDisplayName.length ? JSON.stringify(valueDisplayName) : ''
        } else {
            valueDisplayName = itemUi.options.find(op => op.value == defaultValue)?.displayName
        }
    }
    return valueDisplayName;
}
export function _formatValue(data, value) {
    if (value instanceof Array) {
        // 为数组是多选，需要将数据组成"['xxx','xxx']"并赋给children
        data.defaultValue = JSON.stringify(value)
    } else {
        data.defaultValue = value
    }
    return data
}
// 将_formatValue转换的value反转回来
export function reversValue(data, item) {
    let value = data.defaultValue === null || data.defaultValue === undefined ? '' : data.defaultValue
    const { type, options = [] } = item || {}
    if (typeof value === 'string') {
        const trimmed = value.trim()
        if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
            try {
                const parsed = JSON.parse(trimmed)
                if (Array.isArray(parsed)) {
                    if (type === 'MULTICHECK') {
                        return parsed.filter(v => options.some(op => op.value == v))
                    }
                    if (type === 'SINGLECHECK' && parsed.length) {
                        return parsed.find(v => options.some(op => op.value == v)) || ''
                    }
                }
            } catch (e) {}
        }
        if (type === 'SINGLECHECK' && trimmed) {
            return options.find(op => op.value == trimmed)?.value || ''
        }
        return trimmed
    }
    if (type === 'SINGLECHECK' && value) {
        return options.find(op => op.value == value)?.value || ''
    }
    return value
}

// 处理有children的表单
function _getFormatedItem(item, form) {
    let field = {
        name: item.name.replaceAll('_____', '.')
    }
    
    // needShowMultiComplexFields是特殊的MULTICOMPLEX或者是必填的MULTICOMPLEX类型
    const isNeedShowMultiComplexField = needShowMultiComplexFields.includes(item.name)
    || (item.type === 'MULTICOMPLEX' && item.rules && item.rules.find(i => i.required))
    if (isNeedShowMultiComplexField) {
        const itemChildren = item.children || []
        field.children = form[item.name].map((cv, cvi) => {
            let cv_field = {
                name: `${item.name}_${cvi}`
            }
            let cv_children = []
            for(const cvk in cv) {
                const findCvkItem = itemChildren.find(i => i.name === cvk)
                if(findCvkItem && findCvkItem.isShowFn) {
                    if(findCvkItem.isShowFn(cv)) {
                        cv_children.push(_formatValue({name: cvk}, cv[cvk]))
                    }
                } else {
                    cv_children.push(_formatValue({name: cvk}, cv[cvk]))
                }
            }
            cv_field.children = cv_children
            return cv_field
        })
    } else if (item.children?.length) {
        let children = item.children.map(c => {
            return _getFormatedItem(c, form)
        }).filter(Boolean)
        if (children.length) {
            field.children = children
        } else {
            return false
        }
    } else {
        const value = form[item.name]
        field = _formatValue(field, value)
    }
    return field
}

// 第一步表单的转换
export function step1Form2Data(form) {
    let fieldDescriptorList = []
    for (const name in form) {
        let data = {name}
        const value = form[name]
        fieldDescriptorList.push(_formatValue(data, value))
    }
    return fieldDescriptorList
}
// 第二步的表单转换
export function step2Form2Data(form, propsUI = [], othersUI = []) {
    let fieldDescriptorList = [];

    [...propsUI, ...othersUI].forEach(item => {
        fieldDescriptorList.push(_getFormatedItem(item, form))
    })

    return fieldDescriptorList.filter(Boolean)
}
   /******* 处理wireless_desc 手机端详情描述******/
const get_wireless_desc_data = function(data) {
   let wireless_desc_data = {
        name: 'wireless_desc',
        children: [{
            name: 'item_picture',
            children: []
        }]
    }
    wireless_desc_data.children[0].children = data?.length ? [
        {
            name: 'item_picture_enable',
            defaultValue: 'true'
        },
        ...data.map((wimg, windex) => {
            return {
                name: `image_hot_area_${windex}`,
                children: [{
                    name: 'item_picture_image',
                    defaultValue: wimg
                }]
            }
        })
    ] : [{
        name: 'item_picture_enable',
        defaultValue: 'false'
    }]
    return wireless_desc_data
}
const get_new_wireless_desc_data = function(data,schemaItem,oriDatas=[{}]) {
      let fieldDescriptorList = oriDatas[0].fieldDescriptorList || [];
      let wireless_desc_obj = fieldDescriptorList.find(item => item.name === 'wireless_desc') || {};
      let result = {
        name: 'wireless_desc',
        label: "旺铺无线详情描述",
        children: []
      };
      let version = wireless_desc_obj?.children?.find(i => i.name === 'version');
      if(!version){
        version = {
            defaultValue:'1.0.0',
            name:'version',
            type:'INPUT',
        }
      }
      result.children.push(version);
      let urls = [...data]
      if(urls && urls.length){
        // 获取图片宽高信息，异步调用改的地方有点多，暂时不调了
        // urls = await getImagesSizes(urls);
        urls.forEach((url,i) => {
          let children = [
            {
              defaultValue:'true',
              name:'enable',
              type:'SINGLECHECK'
            },
            {
              children:[
                {
                  defaultValue:url,
                  name:'url',
                  type:'INPUT',
                },
                // {
                //   defaultValue:cfg.width || 0,
                //   name:'width',
                //   type:'INPUT',
                // },
                // {
                //   defaultValue:cfg.height || 0,
                //   name:'height',
                //   type:'INPUT',
                // }
              ],
              name:'image',
              type:'COMPLEX'
            }
          ]
          let obj = {
            children,
            name:`image_hot_area_${i}`,
            type:'COMPLEX'
          }
          result.children.push(obj)
        }); 
      }
      return result
}
const get_images_data = function(data, schemaItem) {
    let images_data = null
    const { name, children } = schemaItem || {}
    images_data = {
        name,
        children: data.map((iimg, iindex) => {
            return {
                name: children[iindex]?.name || `item_image_${iindex}`,
                defaultValue: iimg
            }
        })
    }
    return images_data
}
// 针对auctionVideo数据处理
const formatAuctionVideosData = (auctionVideos, item) => {
  // 基础数据结构
  const baseData = { name: "auctionVideos" };

  // 健壮性校验，防止 item 或 children 为空时报错
  if (!item || !Array.isArray(item.children)) {
    baseData.children = [];
    return baseData;
  }

  // 先过滤出需要的模板，避免每次 map 里都 filter
  const childTemplates = item.children.filter(child => child.name !== 'videoTips');

  baseData.children = (auctionVideos || []).map(video => {
    // 生成每个视频的 children
    const children = childTemplates.map(({ name, label }) => {
      const childItem = { name, label };

      if (name === 'videoType') {
        childItem.defaultValue = video.videoType || "宝贝讲解";
        childItem.valueDisplayName = "";
      } else if (name === 'videoId') {
        childItem.defaultValue = video.videoId;
        if (video.videoInfoJson) {
          childItem.extendValue = {
            [video.videoId]: {
              videoInfoJson: JSON.stringify(video.videoInfoJson)
            }
          };
        }
      }
      return childItem;
    });

    return { children };
  });

  return baseData;
};
// 第三步表单转换
export function step3Form2Data(form, UIs,oriDatas) {
    let fieldDescriptorList = [];
    UIs.forEach(ui => {
        const { name } = ui || {}
        // 自定义数据
        if (['size_model_try'].includes(name)) return;
        let fieldItem = null
        if(['sku', 'postage_id', 'useGroupImages'].includes(name)){
             // 特殊字段处理 (sku特殊字段交由外层获取，因为不需要塞入fieldDescriptorList)
            // (postage_id 也由外层处理，因为需要保存到多个店铺)
        } else if (['wireless_desc'].includes(name)) {
            if(store.state.tmall.isNewWirelessDesc){// 新版无线端详情描述
                fieldItem = get_new_wireless_desc_data(form[name],ui,oriDatas)
            } else {
                fieldItem = get_wireless_desc_data(form[name])
            }
        } else if(['item_images', 'item_wireless_images', 'three_to_four_item_images'].includes(name)) {
            fieldItem = get_images_data(form[name], ui)
        } else if (['auctionVideos'].includes(name)) {
            fieldItem = formatAuctionVideosData(form[name], ui)
        } else {
            fieldItem = _getFormatedItem(ui, form)
        }
        fieldDescriptorList.push(fieldItem)
    });
    return fieldDescriptorList.filter(Boolean)
}

// 合并动态属性的方法
export function merge_fieldDescriptorList(orifields = [], newfields = []) {
    let _ori = JSON.parse(JSON.stringify(orifields))
    let _new = newfields.filter(Boolean)
    _new.forEach(newfield => {
        let index = _ori.findIndex(ori => ori.name === newfield.name)
        if (index > -1) {
            // 若有找到对应的老数据，则替换否则新增
            _ori[index] = newfield
        } else {
            _ori.push(newfield)
        }
    });
    return _ori
}

// 旺铺无线详情描述数据转为表单所需
export function wireless_desc2form(wireless_desc_data, item) {
    if (!wireless_desc_data) return []
    let children = wireless_desc_data.children || []
    if (!children.length) return []

    let item_picture = children.find(({name}) => name === 'item_picture')
    if (!item_picture) return []

    let schemaItem = get((get(item, 'children', []).find(({name}) => name === 'item_picture') || {}), 'children', []);


    let itemChildren = item_picture.children || []
    if(schemaItem.length){
        if (schemaItem[0].defaultValue === 'false') {
            return []
        }
    }
    // if (!schemaItem.length) return []
    // if (schemaItem[0].defaultValue === 'false') {
    //     return []
    // }
    return itemChildren.filter(i => i.name !== 'item_picture_enable').map(i => {
        return (i.children && i.children[0].defaultValue) || ''
    }).filter(Boolean)
}
export function new_wireless_desc2form(wireless_desc_data, item) {
    if (!wireless_desc_data) return []
    if(wireless_desc_data?.children && wireless_desc_data.children.length){
        let imgChildren = wireless_desc_data.children.filter(c => c.name.indexOf('image_hot_area') != -1);
        let imgUrls = imgChildren.map(i => {
        let imageObj = (i.children || []).find(c => c.name === 'image');
        if(imageObj && imageObj.children){
            let urlObj = imageObj.children.find(im => im.name === 'url')
            return urlObj.defaultValue || ''
        }
        return ''
        });
        imgUrls = imgUrls.filter(i => i);
        return imgUrls
    }
    return []
}

// 获取新版手机详情图的宽和高
export async function getWirelessDescWidthAndHeight(fieldDescriptorList,oriFieldDescriptorList){
    let _wireless_desc = fieldDescriptorList.find(item => item.name === 'wireless_desc') || {}
    let versionObj = _wireless_desc.children && _wireless_desc.children.find(item => item.name === 'version')
    if(versionObj){
        let imgMap = {};
        let _children = _wireless_desc.children;
        let oriWirelessDesc = oriFieldDescriptorList.find(field => field.name === 'wireless_desc') || null
        if(oriWirelessDesc){
            // 先把后端返回的数据处理下，提取出图片宽高信息
            (oriWirelessDesc.children || []).forEach(item => {
                if(item.name.indexOf('image_hot_area') != -1){
                    let imageObj = item.children.find(c => c.name === 'image') || {children:[]}
                    let urlObj = imageObj.children.find(c => c.name === 'url') || {}
                    let widthObj = imageObj.children.find(c => c.name === 'width') || {}
                    let heightObj = imageObj.children.find(c => c.name === 'height') || {}
                    imgMap[urlObj.defaultValue] = {
                        width:widthObj.defaultValue || 0,
                        height:heightObj.defaultValue || 0,
                    }
                }
            });
        }
        for(let ch of _children){
            if(ch.name.indexOf('image_hot_area') != -1){
                let imageObj = ch.children.find(c => c.name === 'image') || {children:[]}
                let urlObj = imageObj.children.find(c => c.name === 'url')
                if(urlObj){
                    let url = urlObj.defaultValue;
                    let cfgObj = {};
                    // 已有宽高的优先取有的，没有的再重新获取
                    if(imgMap[url] && imgMap[url].width && imgMap[url].height){
                        cfgObj = imgMap[url]
                    }else{
                        let cfgArr = await getImagesSizes([url]);
                        cfgObj = cfgArr[0]
                    }
                    imageObj.children = imageObj.children.concat([
                        {
                            defaultValue:cfgObj.width || 0,
                            name:'width',
                            type:'INPUT',
                        },
                        {
                            defaultValue:cfgObj.height || 0,
                            name:'height',
                            type:'INPUT',
                        }
                    ])
                }
            }
        }
    }
    return fieldDescriptorList
}
/**
 * 根据图片 URL 获取图片的宽高
 * 返回 Promise，resolve 一个包含 width/height 的对象
 * 注意：读取 naturalWidth/naturalHeight 不涉及跨域像素数据，通常不会触发 CORS 限制
 */
function getImageSizeByUrl(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    // 图片加载成功后读取天然尺寸（优先 naturalWidth/Height，兼容性回退到 width/height）
    img.onload = () => {
      resolve({
        url,
        width: img.naturalWidth || img.width,
        height: img.naturalHeight || img.height
      });
    };
    // 图片加载失败时返回错误，便于上层根据情况兜底
    img.onerror = (e) => {
      reject(e);
    };
    // 触发加载
    img.src = url;
  });
}
/**
 * 批量获取多个图片 URL 的宽高信息
 * 保证整体成功返回：单个失败时兜底为 { width: 0, height: 0 }
 */
export function getImagesSizes(urls = []) {
  const tasks = urls.map(url =>
    getImageSizeByUrl(url).catch(() => ({ width: 0, height: 0,url }))
  );
  return Promise.all(tasks);
}
